import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody, ListGroup, ListGroupItem, Badge, Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { connect } from 'react-redux'
import FileTable from '../tables/FileTable'
import { withAlert } from 'react-alert'



class PortfolioViewModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapse: false,
            files: [],
            files_updated:false,
            ...props
        }

        this.toggleModal = this.toggleModal.bind(this);
        this.collapse = this.collapse.bind(this)
        this.getPortfolioDocuments = this.getPortfolioDocuments.bind(this)
        this.refresh = this.refresh.bind(this);
    }

    componentDidMount() {
        this.getPortfolioDocuments(this.props.document)
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.document !== prevProps.document)
            this.getPortfolioDocuments(this.props.document)
    }

    refresh() {
        this.getPortfolioDocuments(this.props.document);
    }

    getPortfolioDocuments(document) {
        fetch(window.location.protocol + '//' + window.location.host + '/api/archive/portfolio?_id='+document+'&getFile=false')
        .then(res => res.json())
        .then(
            (result) => {
                this.setState({
                    files: result,
                    files_updated: true
                })
            })
        .catch(error=>
            {
                this.props.alert.error('Unable to load portfolio data - ' + error);
                //alert(JSON.stringify(error));
            });
    }

    collapse(){
        this.setState({
            collapse: !this.state.collapse
        })
    }

    toggleModal(){
        this.setState({
            modal: !this.state.modal,
            popoverOpen: false,
            files_updated: false
        });
        this.refresh();
        this.props.toggle(this.state.modal);
        this.props.refresh();
    }

    render()
    {
        return (
            <Modal isOpen={this.props.modal} toggle={this.toggle} className='modal-dialog'>
                <ModalHeader toggle={this.toggleModal}>
                    Portfolio View
                </ModalHeader>
                <ModalBody>
                    <FileTable viewPortfolio={false} refresh={this.refresh} DocumentType={this.props.parentType} DocumentRef={this.props.parentRef} files={this.state.files} />
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={this.toggleModal}>Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default PortfolioViewModal;